import { Subscription } from 'rxjs';
import { Component, Input, OnInit, EventEmitter, Output, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { Collection } from 'src/lib/fliko/types/database.type';
import { SetHlp } from 'src/lib/fliko/helpers/set.helper';
import { NewsNotificationType } from 'src/lib/fliko/models/news/news.data';
import { ErrorHandlingService } from '../../error-handling/error-handling.service';

@Component({
  selector: 'app-notification-type-select',
  templateUrl: './notification-type-select.component.html',
  styleUrls: ['./notification-type-select.component.scss']
})
export class NotificationTypeSelectComponent implements OnInit, OnChanges, OnDestroy {
  @Input() value = new Set<NewsNotificationType>();
  @Output() valueChange = new EventEmitter<Set<NewsNotificationType>>();

  @Input() enabled: {
    mobile?: boolean;
    email?: boolean;
  } = { mobile: true };

  @Input() disabled = false;
  @Input() hideWarning = false;

  @Input() color: 'white' | 'primary' = 'primary';

  public get invalid() {
    this.form.markAllAsTouched();
    return this.form.invalid;
  }

  public form: FormGroup = this.fb.group(
    {
      mobile: this.fb.control(false),
      email: this.fb.control(false)
    },
    { validators: [this.notificationValidity()] }
  );

  private subscription$ = new Subscription();

  constructor(
    private fb: FormBuilder,
    public errorHandlingService: ErrorHandlingService
  ) {}

  ngOnInit(): void {
    this.subscription$.add(
      this.form.valueChanges.subscribe(() => {
        this.value.clear();
        const fVal = this.form.value;
        if (fVal.email) this.value.add(NewsNotificationType.EMAIL);
        if (fVal.mobile) this.value.add(NewsNotificationType.MOBILE);
        this.valueChange.emit(this.value);
      })
    );
    this.patchForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value?.currentValue || changes.enabled?.currentValue) this.patchForm();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  private patchForm(): void {
    // ? set flags to defaults if value field is not set
    this.form.patchValue(
      {
        email: this.enabled.email && SetHlp.has(this.value, NewsNotificationType.EMAIL),
        mobile: this.enabled.mobile && SetHlp.has(this.value, NewsNotificationType.MOBILE)
      },
      { emitEvent: false }
    );
  }

  private notificationValidity(): ValidatorFn {
    return (control: AbstractControl): Collection<any> | null => {
      const form: FormControl = control as FormControl;
      const email = form.get('email')?.value;
      const mobile = form.get('mobile')?.value;
      if (email || mobile) {
        return null;
      }
      return { atLeastOne: true };
    };
  }
}
